/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingGovIcon20Solid = forwardRef('BuildingGovIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m1.385 7.049 6.399-5.236a3.5 3.5 0 0 1 4.432 0l6.399 5.236c.8.654.337 1.951-.696 1.951H17.1v6h.15c.69 0 1.25.56 1.25 1.25v.5c0 .69-.56 1.25-1.25 1.25H2.75c-.69 0-1.25-.56-1.25-1.25v-.5c0-.69.56-1.25 1.25-1.25h.15V9h-.818C1.048 9 .585 7.703 1.385 7.049ZM5.1 9v6h1.8V9H5.1Zm4 0v6h1.8V9H9.1Zm4 0v6h1.8V9h-1.8Z" })));
});
